<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="6">
              <h4 class="card-title mb-0">Edit Banner List</h4>
            </CCol>
            <CCol sm="6" class="card-title text-right" style="color: #2468F6;">
              <div style="cursor: pointer;">
                <CIcon name="cil-cloud-download" class="mr-1" />
                <span @click="downloadMe()">Download Banner Guideline</span>
              </div>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <TryAgain @click="tryMeAgain()" v-if="err !== ''" />
          <CRow v-else>
            <CCol col="12">
              <div role="group" class="form-group form-row">
                <div class="col-sm-3">Revamp</div>
                <div class="col-sm-3">
                  <CSelect
                    :options="optionsRevamp"
                    horizontal
                    placeholder="Select Revamp"
                    :value="data.is_revamp"
                    @change="handleRevamp"
                  />
                </div>
              </div>
              <FormBanner
                field="Desktop Banner"
                :value="valueForm.desktop"
                class="mb-5"
                :expected-image-height-width="data.is_revamp ? imageHeightWidthValidate.desktopRevamp : imageHeightWidthValidate.desktop"
                :previous-image="data.main_desktop_image"
                :key="`bannerDesktop${reset}`"
                @retrieve-file="retrieveDataDesktop"
              />
              <FormBanner
                field="Mobile Banner"
                :value="valueForm.mobile"
                class="mb-5"
                :expected-image-height-width="data.is_revamp ? imageHeightWidthValidate.mobileRevamp : imageHeightWidthValidate.mobile"
                :previous-image="data.main_mobile_image"
                :key="`bannerMobile${reset}`"
                @retrieve-file="retrieveDataMobile"
              />
              <CInput
                label="ALT Banner"
                type="text"
                horizontal
                placeholder="ALT Banner"
                v-model="data.alt_text_image"
                class="mb-5"
              />
              <CInput
                label="URL Path"
                type="text"
                horizontal
                placeholder="URL Path (/promo/detail/artikel-promo)"
                v-model="data.url"
                style="margin-bottom: 0px;"
              />
              <div role="group" class="form-group form-row mb-5">
                <label class="col-form-label">
                  Contoh jika url: https://lionparcel.com/promo/detail/artikel-promo yang di input adalah /promo/detail/artikel-promo.
                </label>
              </div>
              <div role="group" class="form-group form-row mb-5">
                <label class="col-form-label col-sm-3">Display Page</label>
                <div class="col-sm-9">
                  <multiselect
                    horizontal
                    v-model="data.banner_page"
                    :options="optionsDisplayPage"
                    :multiple="true"
                    placeholder="Select Display Page"
                  />
                </div>
              </div>
              <CInput
                label="Priority"
                type="number"
                min="0"
                max="100"
                horizontal
                placeholder="Priority to show on Website"
                v-model="data.priority"
              />
              <CSelect
                label="Language"
                class="language-select"
                :options="filteredLanguages"
                required
                horizontal
                :value="data.language"
                :disabled="isMYBanner"
                @change="handleLanguage"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter v-if="err === ''">
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="$router.go(-1)">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                @click="saveBanner()"
              >
                Save
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BannerListUseCase from "./app/usecase/index.js"
import FormBanner from "./components/FormBanner";
import TryAgain from "./components/TryAgain";
import Multiselect from 'vue-multiselect';

export default {
  name: "BannerListEdit",
  components: { FormBanner, TryAgain, Multiselect },
  data() {
    return {
      data: {
        main_desktop_image: "",
        main_mobile_image: "",
        alt_text_image: "",
        url: "",
        banner_page: [],
        is_revamp: false,
        priority: null,
        language: "ID",
      },
      valueForm: {
        desktop: "",
        mobile: ""
      },
      err: "",
      imageHeightWidthValidate: {
        desktop: {
          max: {
            height: 600,
            width: 2304,
          },
          min: {
            height: 300,
            width: 1152,
          },
        },
        mobile: {
          max: {
            height: 272,
            width: 480,
          },
          min: {
            height: 242,
            width: 426,
          },
        },
        desktopRevamp: {
          max: {
            height: 800,
            width: 1440,
          },
          min: {
            height: 600,
            width: 1080,
          },
        },
        mobileRevamp: {
          max: {
            height: 768,
            width: 432,
          },
          min: {
            height: 640,
            width: 360,
          },
        },
      },
      file: {
        desktop: undefined,
        mobile: undefined,
      },
      optionsRevamp: [{value: true, label: "Yes"}, {value: false, label: "No"}],
      reset: 0,
      optionsLanguage: [
        { label: "Indonesia", value: "ID" },
        { label: "English", value: "EN" },
      ],
      Pages: [
        'Home',
        'CheckPrice',
        'Career',
        'Corporation',
        'Tracking',
        'COD',
        'Agent',
        'DG',
        'Webinar',
        'InfoMitra',
        'InfoSeller',
        'Product',
        'News',
        'Klaim',
        'TrackingClaim',
        'Interpack',
        'Shopify',
      ],
      myPages: [
        'Malaysia',
        'blogMY',
        'ProductMY',
        'TrackingMY',
        'CheckPriceMY',
        'ClaimMY',
        'CODMY',
        'DangerousGoodsMY',
        'CorporationMY',
        'QuarantineMY',
        'AboutUsMY',
        'FAQMY',
        'CareerMY',
        'AgentMY',
        'PromoMY'
      ],
      revampPages: [
        'Promo',
        'Fullfillment',
        'Karantina',
        'FAQ',
        'AgentLocations',
        'AboutUs',
        'LoyaltyProgram'
      ]
    };
  },
  computed: {
    isMYBanner() {
      return Array.isArray(this.data.banner_page) &&
        this.data.banner_page.some(page =>
          this.myPages.includes(page)
        );
    },
    isNonMYBanner() {
      return Array.isArray(this.data.banner_page) &&
        this.data.banner_page.some(page =>
          this.Pages.includes(page)
        );
    },
    filteredLanguages() {
      if (this.isMYBanner) {
        return this.optionsLanguage.filter(lang => lang.value === "EN");
      }

      return this.optionsLanguage;
    },
    optionsDisplayPage() {
      const options = [
        ...this.Pages,
        ...this.myPages
      ]

      const revamp = this.data.is_revamp

      const finalOptions = revamp
        ? [
            ...options,
            ...this.revampPages
          ]
        : options

      // if selected MY page only show MY pages
      if (this.isMYBanner && !this.isNonMYBanner) {
        return finalOptions.filter(page =>
          this.myPages.includes(page)
        )
      }

      // if selected non MY page only show non-MY pages
      if (this.isNonMYBanner && !this.isMYBanner) {
        return finalOptions.filter(page =>
          !this.myPages.includes(page)
        )
      }

      return finalOptions
    },
  },
  watch: {
    isMYBanner(val) {
      if (val) {
        this.data.language = "EN";

        this.data.banner_page = this.data.banner_page.filter(page =>
          this.myPages.includes(page)
        );
      }
    },
    isNonMYBanner(val) {
      if (val && !this.isMYBanner) {
        this.data.banner_page = this.data.banner_page.filter(page =>
          !this.myPages.includes(page)
        );
      }
    }
  },
  methods: {
    handleLanguage(event) {
      if (this.isMYBanner) {
        this.data.language = "EN";
        return;
      }

      this.data.language = event.target.value;
    },
    handleRevamp(event) {
      this.data.is_revamp = JSON.parse(event.target.value);
      this.reset++;
      this.data.main_desktop_image = "";
      this.data.main_mobile_image = ""

      // delete extra revamp only data from selected display page if already selected and when is_revamp = no
      if (!this.data.is_revamp) {
        this.data.banner_page = this.data.banner_page.filter(page => !this.revampPages.includes(page));
      }
    },
    async fetchDataBanner() {
      try {
        const id = this.$route.params.id;
        const { data, err } = await BannerListUseCase.getOne(id)
        if (err) {
          this.err = err
          await this.$swal.fire({
            icon: "error",
            text: err,
          })
        } else {
          this.err = ""
          if (data) {
            this.data = data
            this.valueForm.mobile = this.data.main_mobile_image
            this.valueForm.desktop = this.data.main_desktop_image
            this.data.banner_page = this.data.banner_page ? this.data.banner_page.split(',').filter(val => val) : '';
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        })
      }
    },
    async tryMeAgain() {
      await this.fetchDataBanner()
    },
    retrieveDataMobile(file) {
      this.file.mobile = file
    },
    retrieveDataDesktop(file) {
      this.file.desktop = file
    }, 
    async saveBanner() {
      await this.$swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading()
          try {
            const id = this.$route.params.id;
            const { err } = await BannerListUseCase.editOne(id, this.setFormData())
            if (err) {
              this.$swal.close()
              await this.$swal.fire({
                icon: "error",
                text: err,
              })
            } else {
              this.$swal.close()
              await this.$swal.fire({
                icon: "success",
                text: "banner saved",
              })
              this.$router.push({ path: `/management/banner-list` });
            }
          } catch (err) {
            this.$swal.close()
            await this.$swal.fire({
              icon: "error",
              text: err,
            })
          }
        }
      })
    },
    /** @return {FormData} */
    setFormData() {
      const formData = new FormData()
      formData.append("main_desktop_image", this.file.desktop ? this.file.desktop[0] : '')
      formData.append("main_mobile_image", this.file.mobile ? this.file.mobile[0] : '')
      formData.append("alt_text_image", this.data.alt_text_image)
      formData.append("url", this.data.url)
      formData.append("banner_page", this.data.banner_page.join(","))
      formData.append("is_revamp", this.data.is_revamp)
      if (this.data.priority === "" || this.data.priority === "0" || this.data.priority === undefined) {
        this.data.priority = null
      }
      formData.append("priority", this.data.priority)
      formData.append("language", this.data.language);
      return formData
    },
    downloadMe() {
      window.open("https://storage.googleapis.com/internal-website/guideline/banner-homepage.zip", '_blank').focus();
    }
  },
  async created() {
    await this.fetchDataBanner()
    this.valueForm.mobile = ""
    this.valueForm.desktop = ""
  },
};
</script>
<style scoped>
::v-deep .language-select div{
  max-width: 200px !important;
}
</style>
